import React from "react";
import CustomMenu from "../../../../components/Menu";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import Avatar from "../../../../components/Avatar";
import { createAvtarName, hasImage } from "../../../../utils";

const UserMenu = ({
  users,
  assignUser,
  anchorEl,
  open,
  handleClose,
  cardData,
}) => {
  return (
    <CustomMenu
      id="account-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      className="assign-board-owner-list">
      <CustomMenuItem
        onClick={() =>
          assignUser({
            user_id: "null",
            username: "unassigned",
          })
        }>
        None
      </CustomMenuItem>
      {users?.map((userData) => (
        <CustomMenuItem
          key={`user-avtar-dropdown-card-assign-${userData?.user_id}`}
          onClick={() => assignUser(userData)}
          className={
            cardData?.assigned_to_user_id &&
            cardData?.assigned_to_user_id == userData?.user_id
              ? "active-assign"
              : ""
          }>
          <Avatar
            key={`user-avtar-${userData?.user_id}`}
            username={userData?.username}
            user_image={userData?.user_image}
            title={userData?.username}
            className="user-avtar-dropdown user-avatar mr-8"
            style={
              !hasImage(userData?.user_image) && {
                bgcolor: userData?.profile_color?.background,
                color: userData?.profile_color?.text,
              }
            }>
            {createAvtarName(userData?.username)}
          </Avatar>
          {userData?.username}
        </CustomMenuItem>
      ))}
    </CustomMenu>
  );
};

export default UserMenu;
